import React from 'react';
import { Modal } from 'antd';
import queryString from 'query-string';
import uuidv4 from 'uuid/v4';
import constants from './constants';
import selector from './selector';
import types from './constants';

import messages from '@Util/messages';
import medicalRecordsManagerTypes from '@Components/configuration/MedicalRecord/Forms/config/constant';
import medicalRecordsPerfilTypes from '@Components/perfil/Configuration/MedicalRecord/Forms/config/constant';
import modalConstants from '@Components/common/formEngine/Create/constants';
import * as actionConfig from '@Actions/config';
import * as actionSnack from '@Common/snackBar/action';
import * as actionModal from '@Common/modal/action';
import typeForms from '@Constants/forms';
import typeFields from '@Constants/typeFields';
import * as router from '@Constants/router';
import * as util from '@Util';
import formOrigin from '@Constants/formOrigin';
import selectorLogin from '@Components/login/selector';
import * as actionModalFields from '@Components/ModalFields/action';
import { history } from '@Store';
import dataTypes from '@Constants/typeFields';
import * as actionsScoresFieldReferenceDataDialog from '@Common/ScoresFieldReferenceDataDialog/action';
import { setTabSelectedButtonSelectFromPerfil } from '@App/components/perfil/Configuration/MedicalRecord/Forms/config/actions';
import { setTabSelectedButtonSelectFrom } from '@App/components/configuration/MedicalRecord/Forms/config/actions';

const ModalConfirm = Modal.confirm;
const ModalWarning = Modal.warning;

//#region PRIVATE
const execptionError = (params) => {
  throw params;
};

const isRadioGroupType = (type) => type === typeFields.RADIO_GROUP_TYPE;
const isCheckGroupType = (type) => type === typeFields.CHECKBOX_GROUP_TYPE;
const isInfoType = (type) => type === typeFields.INFO_LABEL_TYPE;
// const isSliderType      = type  => (type === typeFields.SLIDER_TYPE);

const getCalcFieldsWithoutCode = (fields) =>
  Object.values(fields || {}).filter(
    (field) =>
      field.dataType === dataTypes.SCORES_TYPE &&
      !field.preProgrammed &&
      !field.code
  );

const getListFieldsFetchRequest = () => ({
  type: types.FORMS_CREATE_GET_LIST_FIELDS_FETCH_REQUEST,
});
const getListFieldsFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_GET_LIST_FIELDS_FETCH_SUCCESS,
  payload: data,
});
const getListFieldsManagerFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_GET_LIST_FIELDS_MANAGER_FETCH_SUCCESS,
  payload: data,
});
const getListFieldsFetchError = () => ({
  type: types.FORMS_CREATE_GET_LIST_FIELDS_FETCH_ERROR,
});

const getFieldModelByIdFetchRequest = () => ({
  type: types.FORMS_CREATE_GET_MODEL_BY_ID_FETCH_REQUEST,
});
const getFieldModelByIdFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_GET_MODEL_BY_ID_FETCH_SUCCESS,
  payload: data,
});
const getFieldModelByIdFetchError = () => ({
  type: types.FORMS_CREATE_GET_MODEL_BY_ID_FETCH_ERROR,
});

const saveVersionFieldFetchRequest = () => ({
  type: types.FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_REQUEST,
});
const saveVersionFieldFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_SAVE_VERSION_FIELD_FETCH_SUCCESS,
  payload: data,
});

const saveFormsFetchRequest = () => ({
  type: types.FORM_CREATE_SAVE_FETCH_REQUEST,
});
const saveFormsFetchSuccess = () => ({
  type: types.FORM_CREATE_SAVE_FETCH_SUCCESS,
});
const saveFormsFetchError = () => ({
  type: types.FORM_CREATE_SAVE_FETCH_ERROR,
});

const getDraftByIdFetchRequest = () => ({
  type: types.FORM_CREATE_GET_DRAFT_BY_ID_FETCH_REQUEST,
});
const getDraftByIdFetchSuccess = (data) => ({
  type: types.FORM_CREATE_GET_DRAFT_BY_ID_FETCH_SUCCESS,
  payload: data,
});
const getDraftByIdFetchError = () => ({
  type: types.FORM_CREATE_GET_DRAFT_BY_ID_FETCH_ERROR,
});

const saveDraftFetchRequest = () => ({
  type: types.FORM_CREATE_SAVE_DRAFT_FETCH_REQUEST,
});
const saveDraftFetchSuccess = () => ({
  type: types.FORM_CREATE_SAVE_DRAFT_FETCH_SUCCESS,
});
const saveDraftFetchError = () => ({
  type: types.FORM_CREATE_SAVE_DRAFT_FETCH_ERROR,
});

const setSearchFieldsTab = (data) => ({
  type: types.FORMS_CREATE_SET_SEARCH_FIELDS_TAB,
  payload: data,
});
const setSearchFieldsManagerTab = (data) => ({
  type: types.FORMS_CREATE_SET_SEARCH_FIELDS_MANAGER_TAB,
  payload: data,
});
const modalSaveField = (data) => ({
  type: types.FORMS_CREATE_MODAL_SAVE_FIELD,
  payload: data,
});
export const setBuildDraftById = (data) => ({
  type: types.FORMS_CREATE_SET_BUILD_DRAFT_BY_ID,
  payload: data,
});
const setFieldModelVersion = (data) => ({
  type: types.FORMS_CREATE_SET_FIELD_MODEL_VERSION,
  payload: data,
});

const updateConfigFormFetchRequest = (data) => ({
  type: types.FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_REQUEST,
  payload: data,
});
const updateConfigFormFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_SUCCESS,
  payload: data,
});
const updateConfigFormFetchError = () => ({
  type: types.FORMS_CREATE_UPDATE_CONFIG_FORM_FETCH_ERROR,
});
//#endregion

//#region PUBLIC
export const setNewFieldsIds = (data) => ({
  type: types.FORMS_CREATE_SET_NEW_FIELDS_IDS,
  payload: data,
});
export const setNewDynamicFields = (data) => ({
  type: types.FORMS_CREATE_SET_NEW_DYNAMIC_FIELDS,
  payload: data,
});
export const attachPatientModel = (data) => ({
  type: types.FORMS_CREATE_CHANGE_ATTACH_PATIENT_MODEL,
  payload: data,
});

const previewManagerGlobalModelVersionFetchSuccess = (data) => ({
  type: medicalRecordsManagerTypes.CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_SUCCESS,
  payload: data,
});

const previewPerfilGlobalModelVersionFetchSuccess = (data) => ({
  type: medicalRecordsPerfilTypes.PERFIL_CONFIGURATION_EDIT_FORM_MODEL_VERSION_FETCH_SUCCESS,
  payload: data,
});

export const onChangeDataForm = (data) => ({
  type: types.FORMS_CREATE_CHANGE_INPUT_DATA_FORMS,
  payload: data,
});

export const setConfigField = (data) => ({
  type: types.MODALFIELDS_SET_CONFIG_FIELD,
  payload: data,
});

const getImageFormFieldSavedFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_GET_IMAGE_FORM_FIELD_SAVED_FETCH_SUCCESS,
  payload: data,
});

const uploadDocumentFetchRequest = (fileId) => ({
  type: types.FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_REQUEST,
  payload: { fileId },
});

const uploadDocumentFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_SUCCESS,
  payload: data,
});

const uploadDocumentFetchError = (fileId, error) => ({
  type: types.FORMS_CREATE_UPLOAD_DOCUMENT_FETCH_ERROR,
  payload: { fileId, error },
});

const uploadDocumentProgress = (fileId, progress) => ({
  type: types.FORMS_CREATE_UPLOAD_DOCUMENT_PROGRESS,
  payload: { fileId, progress },
});

// Job Stream Actions
const jobStreamConnected = (jobId, fileId) => ({
  type: types.FORMS_CREATE_JOB_STREAM_CONNECTED,
  payload: { jobId, fileId },
});

const jobStreamUpdate = (jobId, data) => ({
  type: types.FORMS_CREATE_JOB_STREAM_UPDATE,
  payload: { jobId, data },
});

const jobStreamError = (jobId, error) => ({
  type: types.FORMS_CREATE_JOB_STREAM_ERROR,
  payload: { jobId, error },
});

const jobStreamClosed = (jobId) => ({
  type: types.FORMS_CREATE_JOB_STREAM_CLOSED,
  payload: { jobId },
});

const processExtractedFormData = (formData) => ({
  type: types.FORMS_CREATE_PROCESS_EXTRACTED_FORM_DATA,
  payload: { formData },
});

const changeIsBlockSave = (data) => ({
  type: types.FORMS_CREATE_CHANGE_IS_BLOCK_SAVE,
  payload: data,
})

const getFieldsLastVersionByFieldModelIdsFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_GET_FIELDS_LAST_VERSION_BY_FIELD_MODEL_IDS_FETCH_SUCCESS,
  payload: data,
});

const replaceBySimilarFieldFetchSuccess = (data) => ({
  type: types.FORMS_CREATE_REPLACE_BY_SIMILAR_FIELD_FETCH_SUCCESS,
  payload: data,
});

const createSessionRequest = () => ({ type: types.FORMBUILDER_CHAT_CREATE_SESSION_REQUEST });
const createSessionSuccess = (data) => ({ type: types.FORMBUILDER_CHAT_CREATE_SESSION_SUCCESS, payload: data });
const createSessionFailure = (error) => ({ type: types.FORMBUILDER_CHAT_CREATE_SESSION_FAILURE, payload: error });

const sendMessageRequest = () => ({ type: types.FORMBUILDER_CHAT_SEND_MESSAGE_REQUEST });
const sendMessageSuccess = (data) => ({ type: types.FORMBUILDER_CHAT_SEND_MESSAGE_SUCCESS, payload: data });
const sendMessageFailure = (error) => ({ type: types.FORMBUILDER_CHAT_SEND_MESSAGE_FAILURE, payload: error });

const finishSessionRequest = () => ({ type: types.FORMBUILDER_CHAT_FINISH_SESSION_REQUEST });
const finishSessionSuccess = (data) => ({ type: types.FORMBUILDER_CHAT_FINISH_SESSION_SUCCESS, payload: data });
const finishSessionFailure = (error) => ({ type: types.FORMBUILDER_CHAT_FINISH_SESSION_FAILURE, payload: error });

const listSessionsRequest = () => ({ type: types.FORMBUILDER_CHAT_LIST_SESSIONS_REQUEST });
const listSessionsSuccess = (data) => ({ type: types.FORMBUILDER_CHAT_LIST_SESSIONS_SUCCESS, payload: data });
const listSessionsFailure = (error) => ({ type: types.FORMBUILDER_CHAT_LIST_SESSIONS_FAILURE, payload: error });

const getSessionRequest = () => ({ type: types.FORMBUILDER_CHAT_GET_SESSION_REQUEST });
const getSessionSuccess = (data) => ({ type: types.FORMBUILDER_CHAT_GET_SESSION_SUCCESS, payload: data });
const getSessionFailure = (error) => ({ type: types.FORMBUILDER_CHAT_GET_SESSION_FAILURE, payload: error });

export const setWebsocketMessage = (message) => ({ type: types.FORMBUILDER_CHAT_SET_WEBSOCKET_MESSAGE, payload: message });
export const setTyping = (isTyping) => ({ type: types.FORMBUILDER_CHAT_SET_TYPING, payload: isTyping });
export const addMessage = (message) => ({ type: types.FORMBUILDER_CHAT_ADD_MESSAGE, payload: message });
export const updateFormPreview = (stats) => ({ type: types.FORMBUILDER_CHAT_UPDATE_FORM_PREVIEW, payload: { stats } });
export const setWebsocketConnected = (connected) => ({ type: types.FORMBUILDER_CHAT_WEBSOCKET_CONNECTED, payload: connected });
export const setWebsocketDisconnected = () => ({ type: types.FORMBUILDER_CHAT_WEBSOCKET_DISCONNECTED });
export const resetFormBuilderChat = () => ({ type: types.FORMBUILDER_CHAT_RESET });



export const managerContextRedirect = (redirectContext, isPublic = false) => (dispatch) => {
  switch (redirectContext) {
    case typeForms.CONTEXT_REDIRECT_PERFIL_CONFIG_MEDICALRECORD_FORMS: {
      dispatch([
        actionConfig.routeRedirect(
          `/${router.ROUTE_BASIC}/${router.PERFIL}/${router.CONFIGURATION}/${router.MEDICAL_RECORD}/${router.FORMS}`
        ),
        setTabSelectedButtonSelectFromPerfil(isPublic ? '2' : '3')
      ]
      );
      break;
    }
    case typeForms.CONTEXT_REDIRECT_CONFIG_MEDICALRECORD_FORMS: {
      dispatch([
        actionConfig.routeRedirect(
          `/${router.MANAGER}/${router.CONFIGURATION}/${router.MEDICAL_RECORD}/${router.FORMS}`
        ),
        setTabSelectedButtonSelectFrom(isPublic ? '1' : '2')
      ]
      );
      break;
    }
    default:
      history.goBack();
      break;
  }
};

export const setUpdateFieldById = (field) => (dispatch, getState, api) => {
  const params = {
    idField: field.id,
    field: {
      enableNewLine: field.enableNewLine,
      enableNewPage: field.enableNewPage,
      enableInline: field.enableInline,
      enableSelectListDesign: field.enableSelectListDesign,
      size: field.size,
      title: field.title,
      fieldName: field.title,
      historyName: field.title,
      historyMeasurementUnit: field.measurementUnit,
      dataType: field.dataType,
      //scoresFieldVersionIds: field.totalFields || [],
      ...field,
      totalFields: [],
    },
  };

  dispatch({
    type: types.FORMS_CREATE_SET_UPDATE_FIELD_BY_ID,
    payload: params,
  });
};

export const searchFieldsTab = (search, selected) => (dispatch, getState, api) => {
  const state = getState();
  const listFields = selector.getListFields(state);
  const originListFields = selector.getOriginalListFields(state);
  const originListFieldsManager = selector.getOriginalListFieldsManager(state);
  const word = util.removedAccent(search.toLowerCase());

  const listFieldsFilter = selected === 'customIds' ? originListFields : originListFieldsManager;

  if (!word.length) {
    const originalFields = selected === 'customIds' ? listFields.customIdsOriginal : listFields.managerIdsOriginal;
    const action = selected === 'customIds' ? setSearchFieldsTab : setSearchFieldsManagerTab;
    dispatch(action({ [selected]: originalFields }));
    return;
  }

  const newCustomIds = listFieldsFilter.filter(field => {
    const nameField = util.removedAccent(field.name.toLowerCase());
    const displayNameField = util.removedAccent(field.displayName.toLowerCase());
    return nameField.includes(word) || displayNameField.includes(word);
  })
    .map(field => field.fieldModelVersionId);

  const action = selected === 'customIds' ? setSearchFieldsTab : setSearchFieldsManagerTab;
  dispatch(action({ [selected]: newCustomIds }));
};


export const setFieldDropEnd =
  ({ field, moduleId, attachedTo = null, externalId = null }) =>
    (dispatch, getState) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      const modules = selector.getDynamicFormsModules(state);

      const uuid = externalId || field.fieldId || uuidv4();

      for (const key in fields) {
        if (fields[key].fieldModelId === field.fieldModelId) {
          if (fields[key].preProgrammed) {
            dispatch(
              actionSnack.showSnackbar({
                message: `O campo selecionado já existe no formulário. Você não pode ter campos repetidos no formulário.`,
                variant: 'error',
                autoHideDuration: 3500,
              })
            );
            return;
          }
          if (!fields[key].attachedTo) {
            dispatch(
              actionSnack.showSnackbar({
                message: `O campo selecionado já existe no formulário. Você não pode ter campos repetidos no formulário.`,
                variant: 'error',
                autoHideDuration: 3500,
              })
            );
            return;
          }
          return;
        }
      }

      let fieldsIds = [];

      const newField = {
        ...field,
        id: uuid,
        attachedTo,
        fieldId: field.fieldId,
      };

      fields[uuid] = newField;
      fieldsIds = [...modules[moduleId].fieldsIds, uuid];

      dispatch({
        type: types.FORMS_CREATE_SET_FIELD_DROP_END,
        payload: {
          fields,
          fieldsIds,
          moduleId,
        },
      });
    };

export const setModuleDropEnd =
  ({ destinationIndex, sourceIndex, sectionDestinationId, sectionOrigenId, draggableId }) =>
    (dispatch, getState) => {
      const state = getState();
      const sections = selector.getDynamicFormsSections(state);
      const modulesIds = Array.from(sections[sectionDestinationId].modulesIds);

      if (sectionOrigenId === sectionDestinationId) {
        const [reorderedItem] = modulesIds.splice(sourceIndex, 1);
        modulesIds.splice(destinationIndex, 0, reorderedItem);
        dispatch({
          type: types.FORMS_CREATE_SET_MODULE_DROP_END,
          payload: {
            modulesIds,
            sectionId: sectionDestinationId,
          },
        });
      } else {
        modulesIds.splice(destinationIndex, 0, draggableId);
        dispatch({
          type: types.FORMS_CREATE_SET_MODULE_DROP_END,
          payload: {
            modulesIds,
            sectionId: sectionDestinationId,
          },
        });

        const modulesIdsRemove = sections[sectionOrigenId].modulesIds;
        const modulesIdsFilter = modulesIdsRemove.filter(item => item !== draggableId)

        dispatch({
          type: types.FORMS_CREATE_SET_MODULE_DROP_END,
          payload: {
            modulesIds: modulesIdsFilter,
            sectionId: sectionOrigenId,
          },
        });
      }
    };

export const setSectionDropEnd =
  ({ destinationIndex, sourceIndex, sectionDestinationId, sectionOrigenId, draggableId }) =>
    (dispatch, getState) => {
      const state = getState();
      const forms = selector.getDynamicFormsForm(state);
      const sectionsIds = Array.from(forms.sectionsIds);

      const [reorderedItem] = sectionsIds.splice(sourceIndex, 1);
      sectionsIds.splice(destinationIndex, 0, reorderedItem);
      dispatch({
        type: types.FORMS_CREATE_SET_SECTION_DROP_END,
        payload: {
          sectionsIds,
        },
      });
    };

export const onChangeHeader =
  ({ value, name }) =>
    (dispatch, getState, api) => {
      dispatch({
        type: types.FORMS_CREATE_CHANGE_INPUT_HEADER,
        payload: { value, name },
      });
    };

export const onChangeSection =
  ({ value, name, idSection }) =>
    (dispatch, getState, api) => {
      dispatch({
        type: types.FORMS_CREATE_CHANGE_INPUT_SECTIONS,
        payload: { value, name, idSection },
      });
    };

export const onChangeModule =
  ({ value, name, idModule }) =>
    (dispatch, getState, api) => {
      dispatch({
        type: types.FORMS_CREATE_CHANGE_INPUT_MODULES,
        payload: { value, name, idModule },
      });
    };

export const resetDynamicForms =
  (props = {}) =>
    (dispatch, getState, api) => {
      const { createSection } = props;
      const resetForms = { type: types.FORMS_CREATE_RESET_DYNAMIC_FORMS };
      dispatch(resetForms);

      if (createSection) dispatch(createNewSection());
    };

export const createNewSection = () => (dispatch, getState, api) => {
  const state = getState();
  const sections = selector.getDynamicFormsSections(state);
  const sectionsIds = selector.getDynamicFormsSectionsIds(state);
  const uuid = util.generateUUID();

  const newSection = {
    id: uuid,
    name: '',
    description: '',
    modulesIds: [],
  };

  sections[uuid] = newSection;
  sectionsIds.push(uuid);

  dispatch([
    {
      type: types.FORMS_CREATE_SET_NEW_SECTION,
      payload: { sections, sectionsIds },
    },
    createNewModule({ idSection: uuid }),
  ]);
};

export const createNewModule =
  ({ idSection }) =>
    (dispatch, getState, api) => {
      const state = getState();
      const sections = selector.getDynamicFormsSections(state);
      const modules = selector.getDynamicFormsModules(state);
      const uuid = util.generateUUID();
      let modulesIds = [];

      const newModule = {
        id: uuid,
        name: '',
        description: '',
        fieldsIds: [],
      };

      modules[uuid] = newModule;
      modulesIds = [...sections[idSection].modulesIds, uuid];

      dispatch({
        type: types.FORMS_CREATE_SET_NEW_MODULES,
        payload: { modules, modulesIds, idSection },
      });
    };

/**
 * Maps feeded fields and matched it's attachedTo id, returning a group of fields
 * @param {*} fields Object
 * @param {*} attachId String
 * @returns Object
 */
const getAttachedFields = (fields, attachId) => {
  let attachedGroup = [];
  Object.keys(fields).map((objectField) => {
    if (fields[objectField].attachedTo === attachId)
      attachedGroup.push(objectField);
  });
  return attachedGroup;
};

export const removeField =
  ({ idField, idModule, intl }) =>
    (dispatch, getState) => {
      const state = getState();
      const modules = selector.getDynamicFormsModules(state);
      let fields = selector.getDynamicFormsFields(state);
      let fieldsIds = modules[idModule].fieldsIds;
      const field = fields[idField];

      const content = intl.formatMessage(
        { ...messages.attachedPreProgrammedFieldRemoveWarning },
        {
          div: (msg) => <div>{msg}</div>,
          br: <br />,
        }
      );

      if (field.attachedTo) {
        const attachedGroup = getAttachedFields(fields, field.attachedTo);
        const attachedNames = attachedGroup.map(
          (attached) => fields[attached].displayName
        );
        ModalConfirm({
          centered: true,
          maskClosable: true,
          title: 'Atenção',
          content: (
            <div>
              {content}
              {attachedNames}
            </div>
          ),
          cancelText: 'Cancelar',
          okText: 'Remover Campos',
          onOk: () => {
            attachedGroup.map((fieldId) => {
              let fieldIndex = fieldsIds.findIndex((item) => item === fieldId);
              fieldsIds.splice(fieldIndex, 1);
              delete fields[fieldId];
            });
            dispatch({
              type: types.FORMS_CREATE_REMOVED_FIELD,
              payload: { fields, fieldsIds, idModule },
            });
          },
          onCancel: () => {
            return;
          },
        });
      } else {
        let fieldIndex = fieldsIds.findIndex((item) => item === idField);
        fieldsIds.splice(fieldIndex, 1);

        delete fields[idField];
      }
      dispatch({
        type: types.FORMS_CREATE_REMOVED_FIELD,
        payload: { fields, fieldsIds, idModule },
      });
    };

export const removeModule =
  ({ idModule, idSection }) =>
    (dispatch, getState, api) => {
      const state = getState();
      let sections = selector.getDynamicFormsSections(state);
      let modules = selector.getDynamicFormsModules(state);
      let fields = selector.getDynamicFormsFields(state);
      let modulesIds = sections[idSection].modulesIds;
      let moduleIndex = modulesIds.findIndex((item) => item === idModule);

      modules[idModule].fieldsIds.forEach((idField) => delete fields[idField]);
      modulesIds.splice(moduleIndex, 1);
      delete modules[idModule];

      dispatch({
        type: types.FORMS_CREATE_REMOVED_MODULE,
        payload: { fields, modules, modulesIds, idSection },
      });
    };

export const removeSection =
  ({ idSection }) =>
    (dispatch, getState, api) => {
      const state = getState();
      let sections = selector.getDynamicFormsSections(state);
      let modules = selector.getDynamicFormsModules(state);
      let fields = selector.getDynamicFormsFields(state);
      let sectionsIds = selector.getDynamicFormsSectionsIds(state);
      let sectionIndex = sectionsIds.findIndex((item) => item === idSection);

      sections[idSection].modulesIds.forEach((idModule) => {
        modules[idModule].fieldsIds.forEach((idField) => delete fields[idField]);
        delete modules[idModule];
      });

      sectionsIds.splice(sectionIndex, 1);
      delete sections[idSection];

      dispatch({
        type: types.FORMS_CREATE_REMOVED_SECTION,
        payload: { sections, sectionsIds, modules, fields },
      });
    };

export const onOpenModal =
  ({ idField }) =>
    (dispatch, getState, api) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      let field = fields[idField];
      let _formOrigin = selector.getFormOrigin(state);
      const modules = selector.getDynamicFormsModules(state);
      const sections = selector.getDynamicFormsSections(state);
      const form = selector.getDynamicFormsForm(state);
      try {
        const updatedFormData = interactionForm(
          form,
          fields,
          modules,
          sections,
          true
        );

        let interactionSections = [];
        updatedFormData.map((section) => {
          // maps each section returning fieldModuleBuilderHelper func for scoresFieldData
          interactionSections = [
            ...interactionSections,
            ...fieldModuleBuilderHelper(section, field),
          ];
        });
        const scoresFieldsData = [...interactionSections];

        const total = scoresFieldsData.map((item, index) => ({
          ...item,
          fieldNumber: item.fieldModelId
        }));

        const newField = {
          uuid: idField,
          size: field.size || 12,
          ...field,
        };

        dispatch([
          actionModal.onOpen({ modal: constants.MODAL_FORMS_UPDATE_FIELD }),
          actionModalFields.editFieldById({
            context: constants.CONTEXT_FORMENGINE_DRAFT_UPDATE,
            modal: constants.MODAL_FORMS_UPDATE_FIELD,
            formOrigin: _formOrigin,
            viewOnly: false,
            field: newField,
            totalFields: total,
          }),
        ]);
      } catch (error) {
        const { message, isNotValidForm } = error;

        if (isNotValidForm && message) {
          dispatch(
            actionSnack.showSnackbar({
              message,
              variant: 'error',
              autoHideDuration: 3500,
            })
          );
          return;
        }

        util.managerExceptionURIMessage({ error, message });
        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };

const fieldsMap = (fields, currentField) => {
  let hasPoints = false;
  let fieldPoints = [];
  for (var key in fields) {
    //Maps the fields with points that are available
    const field = fields[key].fieldData;
    switch (field.dataType) {
      case dataTypes.SCORES_TYPE:
        if (field.fieldId !== currentField.fieldId) {
          if (field.scoresFieldVersionIds.length) hasPoints = true;
        } else hasPoints = false;
        break;
      case dataTypes.CHECKBOX_TYPE:
        const checkBoxPoints = field.points;
        if (
          checkBoxPoints !== null &&
          checkBoxPoints !== undefined &&
          field.checkPoints !== false
        )
          hasPoints = true;
        break;
      case dataTypes.CHECKBOX_GROUP_TYPE:
        const checkBoxGroupPoints = field.checkboxGroup.options[0].points;
        if (checkBoxGroupPoints !== null && checkBoxGroupPoints !== undefined)
          hasPoints = true;
        break;
      case dataTypes.RADIO_GROUP_TYPE:
        const radioGroupPoints = field.radioGroup.options[0].points;
        if (radioGroupPoints !== null && radioGroupPoints !== undefined)
          hasPoints = true;
        break;
      case dataTypes.INT_TYPE:
      case dataTypes.FLOAT_TYPE:
      case dataTypes.DECIMAL_TYPE:
        hasPoints = true;
        break;
      case dataTypes.SLIDER_TYPE:
        hasPoints = true;
        break;
    }
    if (hasPoints) {
      fieldPoints = [...fieldPoints, field]; //New list of fields that holds points
      hasPoints = false;
    }
  }
  return fieldPoints;
};

/** Simple helper to return a built and mapped object from each module
 * @function fieldsMap -> Returns only fields that holds points
 * @param {array} allModules
 * @returns {[{checkboxGroup: Object, dataType: Integer, fieldModelVersionId: Integer,
 *              id: String, isNew: Boolean, module: String, name: String,
 *              order: Integer, points: Integer, radioGroup: Object,
 *              styleConfig: Object
 *          }]}
 */
const fieldModuleBuilderHelper = (allModules, field) => {
  let activePointsFields = [];
  allModules.modules.map((module) => {
    let fieldPoints = fieldsMap(module.fields, field);
    activePointsFields = [...activePointsFields, ...fieldPoints];
  });
  return activePointsFields;
};

/**
 * Dispatches modal actions to open Design Modal
 * @param {String} idField field being consulted
 * @returns dispatch actions
 */
export const onOpenDesignFormField = (idField) => (dispatch, getState, api) => {
  try {
    const state = getState();
    const fields = selector.getDynamicFormsFields(state);
    let field = fields[idField];
    let _formOrigin = selector.getFormOrigin(state);

    const newField = {
      uuid: idField,
      size: field.size || 12,
      ...field,
    };
    dispatch([
      actionModal.onOpen({ modal: constants.MODAL_FORMS_FIELD_DESIGN }),
      actionModalFields.editFieldById({
        context: constants.MODAL_FORMS_FIELD_DESIGN,
        modal: constants.MODAL_FORMS_FIELD_DESIGN,
        formOrigin: _formOrigin,
        viewOnly: false,
        field: newField,
      }),
    ]);
  } catch (error) {
    const { message } = error;
    if (error.isNotValidForm)
      // validates that it is a controlled error output
      util.managerExceptionURIMessage({ error, customMsg: message });
  }
};

export const onOpenCalcEdit = (idField) => (dispatch, getState, api) => {
  try {
    const state = getState();
    const fields = selector.getDynamicFormsFields(state);
    const modules = selector.getDynamicFormsModules(state);
    const sections = selector.getDynamicFormsSections(state);
    const form = selector.getDynamicFormsForm(state);
    const updatedFormData = interactionForm(
      form,
      fields,
      modules,
      sections,
      true
    );
    let field = fields[idField];
    let _formOrigin = selector.getFormOrigin(state);
    let interactionSections = [];
    updatedFormData.map((section) => {
      // maps each section returning fieldModuleBuilderHelper func for scoresFieldData
      interactionSections = [
        ...interactionSections,
        ...fieldModuleBuilderHelper(section, field),
      ];
    });
    const scoresFieldsData = [...interactionSections];

    const total = scoresFieldsData.map((item, index) => ({
      ...item,
      fieldNumber: item.fieldModelId
    }));

    const newField = {
      uuid: idField,
      size: field.size || 12,
      ...field,
    };
    dispatch([
      actionModal.onOpen({
        data: scoresFieldsData,
        modal: constants.MODAL_FORMS_SCORES_MATH,
      }),
      actionModalFields.editFieldById({
        context: constants.CONTEXT_FORMENGINE_DRAFT_UPDATE,
        modal: constants.MODAL_FORMS_SCORES_MATH,
        formOrigin: _formOrigin,
        viewOnly: false,
        field: newField,
        totalFields: total,
      }),
    ]);
  } catch (error) {
    const { message } = error;
    if (error.isNotValidForm)
      // validates that it is a controlled error output
      util.managerExceptionURIMessage({ error, customMsg: message });
  }
};

export const onConfigFieldFormGraphic = (idField) => (dispatch, getState, api) => {
  try {
    const state = getState();
    const fields = selector.getDynamicFormsFields(state);
    const modules = selector.getDynamicFormsModules(state);
    const sections = selector.getDynamicFormsSections(state);
    const form = selector.getDynamicFormsForm(state);
    const updatedFormData = interactionForm(
      form,
      fields,
      modules,
      sections,
      true
    );
    let field = fields[idField];
    let _formOrigin = selector.getFormOrigin(state);
    let interactionSections = [];
    updatedFormData.map((section) => {
      interactionSections = [
        ...interactionSections,
        ...fieldModuleBuilderHelper(section, field),
      ];
    });



    dispatch([
      actionModal.onOpen({
        modal: constants.MODAL_FORMS_CONFIG_FIELD_GRAPHIC,
      }),
      actionModalFields.editFieldById({
        context: constants.MODAL_FORMS_CONFIG_FIELD_GRAPHIC,
        modal: constants.MODAL_FORMS_CONFIG_FIELD_GRAPHIC,
        formOrigin: _formOrigin,
        viewOnly: false,
        field: field,
      }),
    ]);
  } catch (error) {
    const { message } = error;
    if (error.isNotValidForm)
      util.managerExceptionURIMessage({ error, customMsg: message });
  }
};

export const onOpenGraphicConfig = (idField) => (dispatch, getState, api) => {
  try {
    const state = getState();
    const fields = selector.getDynamicFormsFields(state);
    const modules = selector.getDynamicFormsModules(state);
    const sections = selector.getDynamicFormsSections(state);
    const form = selector.getDynamicFormsForm(state);
    const updatedFormData = interactionForm(
      form,
      fields,
      modules,
      sections,
      true
    );
    let field = fields[idField];
    let _formOrigin = selector.getFormOrigin(state);
    let interactionSections = [];
    updatedFormData.map((section) => {
      // maps each section returning fieldModuleBuilderHelper func for scoresFieldData
      interactionSections = [
        ...interactionSections,
        ...fieldModuleBuilderHelper(section, field),
      ];
    });
    const scoresFieldsData = [...interactionSections];

    const total = scoresFieldsData.map((item, index) => ({
      ...item,
      fieldNumber: item.fieldModelId
    }));


    const newField = {
      uuid: idField,
      size: field.size || 12,
      ...field,
    };
    dispatch([
      actionModal.onOpen({
        data: scoresFieldsData,
        modal: constants.MODAL_FORMS_GRAPHIC_CONFIG,
      }),
      actionModalFields.editFieldById({
        context: constants.CONTEXT_FORMENGINE_DRAFT_UPDATE,
        modal: constants.MODAL_FORMS_GRAPHIC_CONFIG,
        formOrigin: _formOrigin,
        viewOnly: false,
        field: newField,
        totalFields: total,
      }),
    ]);
  } catch (error) {
    const { message } = error;
    if (error.isNotValidForm)
      // validates that it is a controlled error output
      util.managerExceptionURIMessage({ error, customMsg: message });
  }
};

export const onCloseModal = ({ idModal }) => {
  return {
    type: types.FORMS_CREATE_MODAL_CLOSE_VISIBILE,
    payload: { idModal },
  };
};

export const onChangeField =
  ({ name, value, idModal }) =>
    (dispatch, getState, api) => {
      const state = getState();
      const modals = selector.getModal(state);

      let modal = modals[idModal];
      let field = modal.field[name];

      const newField = {
        ...field,
        name: value,
      };

      dispatch({
        type: types.FORMS_CREATE_MODAL_CHANGE_INPUT,
        payload: { field: newField, idField: name, idModal },
      });
    };

export const onChangeSize =
  ({ size, idField, idModal }) =>
    (dispatch, getState, api) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      let field = fields[idField];

      field = { ...field, size };

      dispatch({
        type: types.FORMS_CREATE_MODAL_CHANGE_INPUT_SIZE,
        payload: { field, idModal, idField },
      });
    };

export const saveVersionField =
  ({ idField, idModal }) =>
    (dispatch, getState, api) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      let modal = selector.getModal(state);
      let params = {};

      modal = modal[idModal];
      let _field = modal.field[idField];

      let field = { ...fields[_field.id], ..._field };

      if (isRadioGroupType(field.dataType))
        params.radioGroupModelVersionId =
          field.radioGroup.radioGroupModelVersionId;

      if (isCheckGroupType(field.dataType))
        params.checkboxGroupModelVersionId =
          field.checkboxGroup.checkboxGroupModelVersionId;

      if (isInfoType(field.dataType)) params.infoId = field.infoId;

      dispatch(saveVersionFieldFetchRequest());

      params = {
        ...params,
        fieldModelId: field.fieldModelId,
        dataType: field.dataType,
        size: field.size,
      };

      dispatch([
        saveVersionFieldFetchSuccess(),
        modalSaveField({ field, idField }),
        onCloseModal({ idModal }),
        asyncSaveFieldModelVersion({ params, field: fields[_field.id] }),
      ]);
    };

export const updateDynamicFormsFieldsById =
  (field) => (dispatch, getState, api) => {
    const idVersionField = field.fieldModelVersionId;
    const idField = field.id;

    const styleConfig = {
      size: field.size,
      enableNewLine: field.enableNewLine,
      enableNewPage: field.enableNewPage,
      enableInline: field.enableInline,
      enableSelectListDesign: field.enableSelectListDesign,
      enableObservation: field.enableObservation,
      enablePeriodInterval: field.enablePeriodInterval,
    };

    dispatch([
      getFieldModelById(idVersionField, idField, styleConfig),
      getListFields(),
    ]);
  };

export const buildDraftById = (props) => (dispatch, getState, api) => {
  const {
    draft,
    fieldModelVersionsStructures,
    fieldModelsNames,
    infoLabelsNames,
  } = props;

  if (!draft) return;

  const fields = {};
  const mod = {};
  const sections = {};

  const fieldModelVersionsStructuresIndexed = {};
  const fieldModelsNamesIndexed = {};
  const infoLabelsNamesIndexed = {};

  (fieldModelVersionsStructures || []).forEach(
    (item) =>
      (fieldModelVersionsStructuresIndexed[item.fieldModelVersionId] = item)
  );
  (fieldModelsNames || []).forEach(
    (item) => (fieldModelsNamesIndexed[item.fieldModelId] = item)
  );
  (infoLabelsNames || []).forEach(
    (item) => (infoLabelsNamesIndexed[item.infoId] = item)
  );

  const forms = {
    name: draft.name,
    typeForm: draft.typeForm,
    description: draft.description,
    attachPatientModel: draft.attachPatientModel,
    sectionsIds: [],
  };

  for (let section of draft.sections) {
    sections[section.id] = { ...section };
    forms.sectionsIds.push(section.id);

    for (let _mod of section.modules) {
      mod[_mod.id] = { ..._mod };

      for (let field of _mod.fields) {
        let _fieldModelVersionsStructuresIndexed =
          fieldModelVersionsStructuresIndexed[field.fieldModelVersionId] || {};
        let _fieldModelsNamesIndexed =
          fieldModelsNamesIndexed[field.fieldModelId] || {};
        let _infoLabelsNamesIndexed =
          infoLabelsNamesIndexed[field.infoId] || {};

        fields[field.id] = {
          ...field,
          ..._fieldModelVersionsStructuresIndexed,
          ..._fieldModelsNamesIndexed,
          ..._infoLabelsNamesIndexed,
          searchLastVersion: false,
        };
      }
    }
  }

  dispatch(
    setBuildDraftById({
      draftId: draft._id,
      configForm: draft.configForm,
      fields,
      modules: mod,
      sections,
      forms,
    })
  );
};

export const loadPromDraft = (editorDraft) => (dispatch) => {
  
  const draftId = editorDraft && editorDraft.draft && editorDraft.draft._id;

  dispatch(resetDynamicForms({ createSection: false }));
  dispatch(getDraftByIdFetchSuccess({
    draftId,
    hideAttachPatientModel: true,
    formOrigin: formOrigin['FORM_PRONTUARIO'],
  }));

  if (editorDraft && editorDraft.draft) {
    dispatch(buildDraftById(editorDraft));
  }

};

export const buildFormModelById = (props) => (dispatch, getState, api) => {
  const {
    draft,
    fieldModelVersionsStructures,
    fieldModelsNames,
    infoLabelsNames,
  } = props;

  const fields = {};
  const mod = {};
  const sections = {};

  const fieldModelVersionsStructuresIndexed = {};
  const fieldModelsNamesIndexed = {};
  const infoLabelsNamesIndexed = {};

  fieldModelVersionsStructures.forEach(
    (item) =>
      (fieldModelVersionsStructuresIndexed[item.fieldModelVersionId] = item)
  );
  fieldModelsNames.forEach(
    (item) => (fieldModelsNamesIndexed[item.fieldModelId] = item)
  );
  infoLabelsNames.forEach(
    (item) => (infoLabelsNamesIndexed[item.infoId] = item)
  );

  const forms = {
    name: draft.name,
    description: draft.description,
    attachPatientModel: draft.attachPatientModel,
    sectionsIds: [],
  };

  for (let section of draft.sections) {
    sections[section.id] = { ...section };
    forms.sectionsIds.push(section.id);

    for (let _mod of section.modules) {
      mod[_mod.id] = { ..._mod };

      for (let field of _mod.fields) {
        let _fieldModelVersionsStructuresIndexed =
          fieldModelVersionsStructuresIndexed[field.fieldModelVersionId] || {};
        let _fieldModelsNamesIndexed =
          fieldModelsNamesIndexed[field.fieldModelId] || {};
        let _infoLabelsNamesIndexed =
          infoLabelsNamesIndexed[field.infoId] || {};

        fields[field.id] = {
          ...field,
          ..._fieldModelVersionsStructuresIndexed,
          ..._fieldModelsNamesIndexed,
          ..._infoLabelsNamesIndexed,
          searchLastVersion: false,
        };
      }
    }
  }

  dispatch(
    setBuildDraftById({
      draftId: draft._id,
      fields,
      modules: mod,
      sections,
      forms,
    })
  );
  dispatch(actionModal.onOpen({ modal: modalConstants.MODAL_FORMS_PREVIEW }))
};

/**
 * Validates and mounts form sections based on the draft
 * @param {Object} form  getDynamicFormsForms
 * @param {Object} fields getDynamicFormsFields
 * @param {Object} modules getDynamicFormsModules
 * @param {Object} sections getDynamicFormsSections
 * @param {Boolean} calcValidation boolean to check if its Scores Field form data validation
 * @returns validated and updated section
 */
const interactionForm = (
  form,
  fields,
  modules,
  sections,
  calcValidation = false
) => {
  const newSection = [];
  let indexSection = 0;

  const fieldsByFieldModelId = {};

  Object.keys(fields).forEach((key) => {
    const field = fields[key];
    fieldsByFieldModelId[field.fieldModelId] = field;
  });

  if (!form.name || !form.name.trim().length)
    execptionError({
      isNotValidForm: true,
      message: 'Por favor informe o nome do Formulário!',
    });

  for (let idSection of form.sectionsIds) {
    const section = sections[idSection];
    const _modules = [];
    let indexModule = 0;

    if (!section.name || !section.name.trim().length)
      execptionError({
        isNotValidForm: true,
        message: 'Por favor informe o nome da Seção!',
        idSection: section.id,
      });

    for (let idModule of section.modulesIds) {
      let mod = modules[idModule];
      let _fields = [];
      let indexField = 0;

      if (!mod.name || !mod.name.trim().length)
        execptionError({
          isNotValidForm: true,
          message: `Por favor informe o nome do Modulo na Seção: ${section.name.toUpperCase()}!`,
          idSection: section.id,
          idModule: mod.id,
        });

      for (let idField of mod.fieldsIds) {
        const field = fields[idField];
        _fields.push({
          isNew: true,
          order: indexField,
          fieldModelVersionId: field.fieldModelVersionId,
          fieldData: {
            ...field, module: mod.name, scoresFieldVersionIds: field.scoresFieldVersionIds ? field.scoresFieldVersionIds.map(
              item => {
                const fieldModel = fieldsByFieldModelId[item.fieldModelId];
                if (!fieldModel) return null;
                return {
                  fieldId: fieldModel.fieldId,
                  fieldModelVersionId: fieldModel.fieldModelVersionId,
                  fieldNumber: fieldModel.fieldModelId,
                  fieldModelId: fieldModel.fieldModelId,
                };
              }
            ).filter(item => item != null) : []
          },
          fieldId: field.fieldId,
          codeConfig: field.codeConfig,
          measurementUnit: field.measurementUnit,
          isModelField: field.isModelField,
          styleConfig: {
            size: field.size || 12,
            enableNewLine: field.enableNewLine || false,
            enableNewPage: field.enableNewPage || false,
            enableInline: field.enableInline || false,
            enableSelectListDesign: field.enableSelectListDesign || false,
            enableObservation: field.enableObservation || false,
            enablePeriodInterval: field.enablePeriodInterval || false,
          },
        });

        ++indexField;
      }

      if (!_fields.length && !calcValidation)
        execptionError({
          isNotValidForm: true,
          message: `Por favor informe pelo menos um Campo no Modulo: ${mod.name}!`,
          idSection: section.id,
          idModule: mod.id,
        });

      _modules.push({
        name: mod.name,
        description: mod.description,
        order: indexModule,
        fields: _fields,
        isNew: true,
      });

      ++indexModule;
    }

    newSection.push({
      name: section.name,
      description: section.description,
      isNew: true,
      order: indexSection,
      modules: _modules,
    });

    ++indexSection;
  }

  return newSection;
};

export const buildDraftForm = (form, fields, modules, sections) => {
  const newSection = [];
  let indexSection = 0;

  for (let idSection of form.sectionsIds) {
    const section = sections[idSection];
    const _modules = [];
    let indexModule = 0;

    for (let idModule of section.modulesIds) {
      let mod = modules[idModule];
      let _fields = [];
      let indexField = 0;

      for (let idField of mod.fieldsIds) {
        const field = fields[idField];
        _fields.push({
          order: indexField,
          searchLastVersion: false,
          ...field,
        });

        ++indexField;
      }

      if (!_fields.length)
        execptionError({
          isNotValidForm: true,
          message: `Por favor informe pelo menos um Campo no Modulo: ${mod.name}!`,
          idSection: section.id,
          idModule: mod.id,
        });

      _modules.push({
        ...mod,
        order: indexModule,
        fields: _fields,
      });

      ++indexModule;
    }

    newSection.push({
      ...section,
      order: indexSection,
      modules: _modules,
    });

    ++indexSection;
  }

  return newSection;
};
//#endregion

//region APIs
export const getListFields =
  (formOrigin, listType = 'all') =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let _formOrigin = formOrigin || selector.getFormOrigin(state);
      header = { ...header, formOrigin: _formOrigin };

      try {
        dispatch(getListFieldsFetchRequest());

        let response = await apiForms.field.getFields({ header, listType });
        let items = {};
        let customIds = [];
        let managerIds = [];

        if (listType === 'manager') {
          response.data.forEach((item, index) => {
            items[item.fieldModelVersionId] = { index, ...item };
            managerIds.push(item.fieldModelVersionId);
          });
          const listFields = { items, managerIds };
          dispatch(getListFieldsManagerFetchSuccess({ listFields, data: response.data }));
        }
        else {
          response.data.forEach((item, index) => {
            items[item.fieldModelVersionId] = { index, ...item };
            if (item.modelField) {
              managerIds.push(item.fieldModelVersionId);
            }
            customIds.push(item.fieldModelVersionId);
          });

          const listFields = { items, customIds };
          dispatch(getListFieldsFetchSuccess({ listFields, data: response.data }));
        }

      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(getListFieldsFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
        // window.location = systemConfigs.AUTH_DOMAIN;
      }
    };

export const getFieldModelById =
  (idVersionField, idField, externalId, styleConfig = {}) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let _formOrigin = selector.getFormOrigin(state);
      header = {
        ...header,
        formOrigin: _formOrigin || formOrigin['FORM_PRONTUARIO'],
      };

      try {
        dispatch(getFieldModelByIdFetchRequest());

        const response = await apiForms.field.getFieldModelById({
          header,
          idVersionField,
        });
        const result = response.data;

        const newResult = {
          ...result,
          fieldId: result.fieldId || externalId || uuidv4(),
          ...styleConfig,
        };

        dispatch(
          getFieldModelByIdFetchSuccess({
            idField,
            result: newResult,
          })
        );
      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(getFieldModelByIdFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
        // window.location = systemConfigs.AUTH_DOMAIN;
      }
    };

export const getFieldModelDataById =
  (idVersionField, idField, styleConfig = {}) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let _formOrigin = selector.getFormOrigin(state);
      header = {
        ...header,
        formOrigin: _formOrigin || formOrigin['FORM_PRONTUARIO'],
      };
      try {
        const response = await apiForms.field.getFieldModelById({
          header,
          idVersionField,
        });

        const result = response.data;

        return result;
      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(getFieldModelByIdFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };

export const asyncSaveFieldModelVersion =
  ({ params, field }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let items = selector.getListFieldsItems(state);
      let fields = selector.getDynamicFormsFields(state);
      let formOrigin = selector.getFormOrigin(state);
      header = { ...header, formOrigin };

      try {
        const response = await apiForms.field.saveFieldModelVersion({
          header,
          params,
        });

        const { fieldModelVersionId } = response.data;

        items[field.fieldModelId] = {
          ...items[field.fieldModelId],
          fieldModelVersionId,
        };

        fields[field.id] = { ...fields[field.id], fieldModelVersionId };

        dispatch(setFieldModelVersion({ items, fields }));
      } catch (error) {
        dispatch(modalSaveField({ field, idField: field.id }));
        dispatch(
          actionSnack.showSnackbar({
            message: `Não foi possível salvar a alteração do campo: ${field.fieldName}`,
            variant: 'error',
            autoHideDuration: 3500,
          })
        );
      }
    };

const doCheckNameAndPublish =
  ({ search }, setScoresFieldReferenceDataDialog) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      const nameForm = selector.getDynamicFormsName(state);
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);
      let fields = selector.getDynamicFormsFields(state);
      let allScoresFieldsIds = [];

      for (const key in fields) {
        if (fields[key].preProgrammed) {
          fields[key].scoresFieldVersionIds.map((field) => {
            const newFields = Object.values(fields);
            const alreadyInScoresFieldsId = allScoresFieldsIds.some(
              (item) => item.nameOfScoresField === fields[key].displayName
            );
            if (!alreadyInScoresFieldsId)
              allScoresFieldsIds.push({
                fieldId: field.fieldId,
                nameOfScoresField: fields[key].displayName,
                has: newFields.some((item) => item.fieldId === field.fieldId),
              });
            else return;
          });
        }
      }

      const isMissingSomeField = allScoresFieldsIds.filter(
        (item) => item.has === false
      );

      header = { ...header, formOrigin };

      if (isMissingSomeField.length) {
        const names = isMissingSomeField
          .map((item) => item.nameOfScoresField)
          .join(', ');
        ModalWarning({
          centered: true,
          maskClosable: false,
          title: 'Atenção',
          content: (
            <div>
              <p>
                Faltam campos necessários para realizar os cálculos{' '}
                {isMissingSomeField.length > 1 ? 'dos campos:' : 'do campo:'}
                <strong style={{ marginLeft: '2px' }}>{names}</strong>
              </p>
              <p>
                Por favor, revise os campos de cálculo e inclua os campos ausentes
                no formulário; ou apenas retire os campos de calculo do formulário
                e acrescente novamente para que o próprio sistema corrija os
                campos.
              </p>
            </div>
          ),
        });
      } else {
        try {
          if (!nameForm || !nameForm.length) {
            dispatch(
              actionSnack.showSnackbar({
                message: 'Por favor inserir o nome do Modelo do Formulário',
                variant: 'error',
                autoHideDuration: 3500,
              })
            );
            return;
          }

          dispatch(saveFormsFetchRequest());

          let execute = () => { };

          if (header.workspaceId) {
            //nivel workspace
            execute = apiForms.form.checkNameFormModel;
          } else {
            execute = apiForms.form.checkNameAccountFormModel;
          }

          let response = await execute({
            header,
            nameForm: encodeURIComponent(nameForm),
          });
          let isAvaliable = response.data.isAvailable;

          if (!isAvaliable) {
            ModalConfirm({
              centered: true,
              maskClosable: true,
              title: 'Atenção',
              content: `Já existe um modelo salvo com esse nome "${nameForm}". O que você deseja fazer? Substituir o modelo antigo por essa nova versão ou renomear o modelo atual?`,
              cancelText: 'Renomear',
              okText: 'Substituir',
              onOk: () => {
                dispatch(
                  saveForms({ search }, setScoresFieldReferenceDataDialog)
                );
              },
              onCancel: () => {
                dispatch(saveFormsFetchError());
              },
            });
          } else {
            dispatch(saveForms({ search }, setScoresFieldReferenceDataDialog));
          }
        } catch (error) {
          const { msg } = error;
          const customMsg = !!msg;

          dispatch(saveFormsFetchError());
          util.managerExceptionURIMessage({ error, customMsg });

          if (error && error.status === 401)
            dispatch(actionConfig.routeRedirect('/'));
          // window.location = systemConfigs.AUTH_DOMAIN;
        }
      }
    };

export const checkNameFormModel =
  ({ search }, setScoresFieldReferenceDataDialog) =>
    (dispatch, getState) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      const invalidCalcFields = getCalcFieldsWithoutCode(fields);

      if (invalidCalcFields.length > 0) {
        const fieldNames = invalidCalcFields
          .map((f) => f.displayName || f.title || 'Campo sem nome')
          .join(', ');

        ModalConfirm({
          centered: true,
          maskClosable: false,
          title: 'Campos de cálculo sem fórmula',
          content: `Os seguintes campos do tipo "Cálculo" não possuem uma fórmula configurada e não serão calculados ao preencher o formulário:\n\n• ${fieldNames}\n\nDeseja publicar mesmo assim ou voltar e corrigir?`,
          okText: 'Publicar com o problema',
          cancelText: 'Voltar e corrigir',
          onOk: () => dispatch(doCheckNameAndPublish({ search }, setScoresFieldReferenceDataDialog)),
          onCancel: () => {},
        });
        return;
      }

      dispatch(doCheckNameAndPublish({ search }, setScoresFieldReferenceDataDialog));
    };

export const saveForms =
  ({ search }, setScoresFieldReferenceDataDialog) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      const modules = selector.getDynamicFormsModules(state);
      const sections = selector.getDynamicFormsSections(state);
      const form = selector.getDynamicFormsForm(state);
      const draftId = selector.getDynamicFormsDraftId(state);
      const configForm = selector.getConfigForm(state);
      const hideAttachPatientModel = selector.getIsHideAttachPatientModel(state);
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);
      let parsed = queryString.parse(search);
      let params = {};
      header = { ...header, formOrigin };

      const pathname = state.router.location.pathname;
      const isAccountFormPath = pathname.startsWith("/manager") ? true : false;

      params = {
        configForm,
        isAccountForm: isAccountFormPath,
        form: {
          draftId,
          name: form.name,
          typeForm: form.typeForm,
          description: form.description,
          attachPatientModel: form.attachPatientModel || hideAttachPatientModel,
          sections: [],
        },
      };

      try {
        dispatch(saveFormsFetchRequest());
        params.form.sections = interactionForm(form, fields, modules, sections);

        await apiForms.form.saveForm({ header, params });

        dispatch([
          actionsScoresFieldReferenceDataDialog.setDialogTriggerState(false),
          saveFormsFetchSuccess(),
          resetDynamicForms(),
          managerContextRedirect(parsed.redirect, true),
        ]);
      } catch (error) {
        const { message, isNotValidForm } = error;

        dispatch(saveFormsFetchError());
        //Setar aqui os fieldIds do diálogo?
        if (isNotValidForm && message) {
          dispatch(
            actionSnack.showSnackbar({
              message,
              variant: 'error',
              autoHideDuration: 3500,
            })
          );
          return;
        }

        util.managerExceptionURIMessage({ error, message });
        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };

export const saveDraft =
  () =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      const fields = selector.getDynamicFormsFields(state);
      const modules = selector.getDynamicFormsModules(state);
      const sections = selector.getDynamicFormsSections(state);
      const draftId = selector.getDynamicFormsDraftId(state);
      const form = selector.getDynamicFormsForm(state);
      const configForm = selector.getConfigForm(state);
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);
      header = { ...header, formOrigin };

      try {
        let params = {};

        dispatch(saveDraftFetchRequest());

        const pathname = state.router.location.pathname;
        const isAccountFormPath = pathname.startsWith("/manager") ? true : false;

        params = {
          isAccountForm: isAccountFormPath,
          draft: {
            _id: draftId,
            name: form.name,
            typeForm: form.typeForm,
            description: form.description,
            attachPatientModel: form.attachPatientModel,
            workspaceId: selectorLogin.getAuthBusinessWorkspaceId(state),
            sections: [],
            configForm,
          },
        };

        params.draft.sections = buildDraftForm(form, fields, modules, sections);

        await apiForms.form.putDraft({ header, params });

        dispatch([
          saveDraftFetchSuccess(),
          actionSnack.showSnackbar({
            message: 'Todas as alterações foram salvas!',
          }),
        ]);
      } catch (error) {
        const { msg, isNotValidForm, message } = error;
        const customMsg = !!msg;

        dispatch(saveDraftFetchError());

        if (isNotValidForm && message) {
          dispatch(
            actionSnack.showSnackbar({
              message,
              variant: 'error',
              autoHideDuration: 3500,
            })
          );
          return;
        }

        util.managerExceptionURIMessage({ error, customMsg });

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
        // window.location = systemConfigs.AUTH_DOMAIN;
      }
    };

export const getDraftById =
  ({ draftId, formOriginId }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      header = { ...header, formOrigin: formOriginId };

      let hideAttachPatientModel =
        Number(formOriginId) === formOrigin['FORM_PRONTUARIO'];

      try {
        dispatch(getDraftByIdFetchRequest());

        let resDraftById = await apiForms.form.getDraftById({ header, draftId });
        let draft = resDraftById.data.draft;

        if (!draft.sections.length) {
          dispatch([
            resetDynamicForms({ createSection: true }),
            getDraftByIdFetchSuccess({
              draftId,
              hideAttachPatientModel,
              formOrigin: formOriginId,
            }),
          ]);
          return;
        }

        dispatch([
          getDraftByIdFetchSuccess({
            draftId,
            hideAttachPatientModel,
            formOrigin: formOriginId,
          }),
          buildDraftById(resDraftById.data),
        ]);
      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(getDraftByIdFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
        // window.location = systemConfigs.AUTH_DOMAIN;
      }
    };

export const getPreviewDraftById =
  ({ draftId, formOriginId, acessedFrom }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      header = { ...header, formOrigin: formOriginId };

      let hideAttachPatientModel =
        Number(formOriginId) === formOrigin['FORM_PRONTUARIO'];

      const previewFetchSuccess = () => {
        if (acessedFrom === 'manager')
          return previewManagerGlobalModelVersionFetchSuccess();
        return previewPerfilGlobalModelVersionFetchSuccess();
      };
      try {
        dispatch(getDraftByIdFetchRequest());

        let resDraftById = await apiForms.form.getDraftById({ header, draftId });
        let draft = resDraftById.data.draft;

        if (!draft.sections.length) {
          dispatch([
            resetDynamicForms({ createSection: true }),
            getDraftByIdFetchSuccess({
              draftId,
              hideAttachPatientModel,
              formOrigin: formOriginId,
            }),
          ]);
          return;
        }
        dispatch([
          getDraftByIdFetchSuccess({
            draftId,
            hideAttachPatientModel,
            formOrigin: formOriginId,
          }),
          buildDraftById(resDraftById.data),
          actionModal.onOpen({ modal: modalConstants.MODAL_FORMS_PREVIEW }),
          previewFetchSuccess(),
        ]);
        return;
      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(getDraftByIdFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };


export const updateConfigForm =
  ({ formId }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);

      const params = {
        formId,
        configForm,
      };


      try {
        dispatch(updateConfigFormFetchRequest());

        await apiForms.form.updateConfigForm({ header, params });

        dispatch([
          updateConfigFormFetchSuccess(),
        ]);
        return;
      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        util.managerExceptionURIMessage({ error, customMsg });
        dispatch(updateConfigFormFetchError());

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };

export const getImageForm =
  ({ fileReference, fileName }) =>
    async (dispatch, getState, { apiFiles }) => {
      const state = getState();
      const header = selectorLogin.getHeaderConfig(state);

      try {
        const params = {
          fileReference,
          fileName,
        };

        const image = await apiFiles.files.downloadImageFormFile({
          header,
          params,
        });
        const arrayBuffer = await image.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        const base64url = `data:image/png;base64,${buffer.toString('base64')}`;

        dispatch(
          getImageFormFieldSavedFetchSuccess({
            base64url,
            fileReference,
          })
        );
      } catch (error) {
        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
        // window.location = systemConfigs.AUTH_DOMAIN;
      }
    };

export const uploadDocumentForTextExtraction =
  ({ file, fileId }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);
      header = { ...header, formOrigin };

      try {
        dispatch(uploadDocumentFetchRequest(fileId));

        const onUploadProgress = (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          dispatch(uploadDocumentProgress(fileId, progress));
        };

        const uploadResponse = await apiForms.form.uploadDocumentForExtraction({
          header,
          params: { file },
          onUploadProgress,
        });

        dispatch(uploadDocumentFetchSuccess({
          fileId,
          uploadData: uploadResponse.data,
        }));
        if (uploadResponse.data.jobId) {
          dispatch(startJobStreaming({
            jobId: uploadResponse.data.jobId,
            fileId: fileId
          }));
        }

      } catch (error) {
        const { msg } = error;
        const customMsg = !!msg;

        if (error.status === 402 && error.response?.message === 'INSUFFICIENT_TOKENS') {
          const insufficientTokensError = {
            ...error,
            isInsufficientTokens: true,
            userFeedback: error.response.userFeedback,
            tokenData: error.response.data
          };

          dispatch(uploadDocumentFetchError(fileId, insufficientTokensError));
          dispatch(
            actionSnack.showSnackbar({
              message: error.response.userFeedback || 'Tokens insuficientes para processar o documento',
              variant: 'warning',
              autoHideDuration: 5000,
            })
          );
        } else {
          dispatch(uploadDocumentFetchError(fileId, error));
          dispatch(
            actionSnack.showSnackbar({
              message: `Erro no upload do arquivo: ${file.name}`,
              variant: 'error',
              autoHideDuration: 3500,
            })
          );

          util.managerExceptionURIMessage({ error, customMsg });
        }

        if (error && error.status === 401)
          dispatch(actionConfig.routeRedirect('/'));
      }
    };

export const getFieldsLastVersionByFieldModelIds =
  (fieldModelIds) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);

      try {
        const params = {
          fieldModelIds,
        };

        const response = await apiForms.form.getFieldsLastVersionByFieldModelIds({ header, params });

        dispatch(getFieldsLastVersionByFieldModelIdsFetchSuccess(response.data));
      } catch (error) {
        util.managerExceptionURIMessage({ error });
      }
    }


export const startJobStreaming =
  ({ jobId, fileId }) =>
    async (dispatch, getState, { apiForms }) => {
      const state = getState();
      let header = selectorLogin.getHeaderConfig(state);
      let formOrigin = selector.getFormOrigin(state);
      header = { ...header, formOrigin };

      try {
        dispatch(jobStreamConnected(jobId, fileId));

        const closeStream = await apiForms.form.streamJobProgress({
          jobId,
          header,
          onMessage: (streamData) => {
            if (streamData.event !== 'connected' && streamData.event !== 'heartbeat') {
              dispatch(jobStreamUpdate(jobId, streamData.data));

              if (streamData.data.status === 'done' && streamData.event !== 'final') {
                dispatch(
                  actionSnack.showSnackbar({
                    message: 'Processamento concluído com sucesso!',
                    variant: 'success',
                    autoHideDuration: 3000,
                  })
                );
              } else if (streamData.data.status === 'done' && streamData.event === 'final') {
                if (streamData.data.result && streamData.data.result.structure && streamData.data.result.fields) {

                  const fieldsIdsSimilar = streamData.data.result.fields.map(field => {
                    if (field.similarityScore > 70) {
                      return field.similarFieldId;
                    }
                    return null;
                  });

                  const fieldsIdsSimilarFiltered = fieldsIdsSimilar.filter(field => field !== null);

                  if (fieldsIdsSimilar.length > 0) {
                    dispatch(getFieldsLastVersionByFieldModelIds(fieldsIdsSimilarFiltered));
                  }

                  dispatch(processExtractedFormData(streamData.data.result));
                  dispatch(changeIsBlockSave(false))
                  dispatch(
                    actionSnack.showSnackbar({
                      message: 'Formulário extraído e carregado com sucesso!',
                      variant: 'success',
                      autoHideDuration: 3000,
                    })
                  );
                }
                closeStream();
              } else if (streamData.data.status === 'result_partial') {
                if (streamData.data.result && streamData.data.result.fields) {
                  dispatch(processExtractedFormData({ ...streamData.data.result, resultPartial: true }));
                  dispatch(
                    actionSnack.showSnackbar({
                      message: 'Formulário extraído e carregado com sucesso!',
                      variant: 'success',
                      autoHideDuration: 3000,
                    })
                  );
                }
              }
              else if (streamData.data.status === 'error') {
                dispatch(
                  actionSnack.showSnackbar({
                    message: 'Erro no processamento do documento',
                    variant: 'error',
                    autoHideDuration: 3500,
                  })
                );
                closeStream();
              }
            }
          },
          onError: (error) => {
            dispatch(jobStreamError(jobId, error));
            dispatch(
              actionSnack.showSnackbar({
                message: 'Erro na conexão com o stream de processamento',
                variant: 'error',
                autoHideDuration: 3500,
              })
            );
          },
          onClose: () => {
            dispatch(jobStreamClosed(jobId));
          }
        });

        dispatch({
          type: 'STORE_STREAM_CLOSER',
          payload: { jobId, closeStream }
        });

      } catch (error) {
        dispatch(jobStreamError(jobId, error));
        util.managerExceptionURIMessage({ error });
      }
    };

export const backupCurrentForm = () => (dispatch, getState) => {
  const state = getState();
  const fields = selector.getDynamicFormsFields(state);
  const modules = selector.getDynamicFormsModules(state);
  const sections = selector.getDynamicFormsSections(state);
  const form = selector.getDynamicFormsForm(state);

  const backup = {
    fields: { ...fields },
    modules: { ...modules },
    sections: { ...sections },
    form: { ...form }
  };

  dispatch({
    type: types.FORMBUILDER_CHAT_BACKUP_FORM,
    payload: backup
  });
};


export const restoreFormFromBackup = () => (dispatch, getState) => {
  const state = getState();
  const backup = state.formEngine.create.formBuilderChat.backupForm;

  if (!backup) {
    dispatch(actionSnack.showSnackbar({
      message: 'Não há backup disponível para restaurar',
      variant: 'warning',
      autoHideDuration: 2000
    }));
    return;
  }

  dispatch({
    type: types.FORMBUILDER_CHAT_RESTORE_FORM,
    payload: backup
  });

  dispatch(actionSnack.showSnackbar({
    message: 'Formulário restaurado com sucesso!',
    variant: 'success',
    autoHideDuration: 2000
  }));
};


export const createFormBuilderSession = ({ formName, initialMessage }) =>
  async (dispatch, getState, { apiForms }) => {
    const state = getState();
    let header = selectorLogin.getHeaderConfig(state);
    const formOrigin = selector.getFormOrigin(state);
    header = { ...header, formOrigin };

    try {
      dispatch(createSessionRequest());

      const response = await apiForms.form.createFormBuilderSession({
        header,
        formName,
        initialMessage
      });

      dispatch(createSessionSuccess(response));

      dispatch(actionSnack.showSnackbar({
        message: 'Sessão iniciada com sucesso!',
        variant: 'success',
        autoHideDuration: 2000
      }));

      return response;
    } catch (error) {
      const { msg } = error;
      const customMsg = !!msg;

      dispatch(createSessionFailure(error));
      dispatch(actionSnack.showSnackbar({
        message: msg || 'Erro ao criar sessão de chat',
        variant: 'error',
        autoHideDuration: 3500
      }));

      util.managerExceptionURIMessage({ error, customMsg });
      throw error;
    }
  };


export const sendFormBuilderMessage = ({ sessionId, message }) =>
  async (dispatch, getState, { apiForms }) => {
    const state = getState();
    let header = selectorLogin.getHeaderConfig(state);
    const formOrigin = selector.getFormOrigin(state);
    header = { ...header, formOrigin };

    const draftId = selector.getDynamicFormsDraftId(state);
    const fields = selector.getDynamicFormsFields(state);
    const sections = selector.getDynamicFormsSections(state);

    const hasExistingFields = fields && Object.keys(fields).length > 0;
    const hasExistingSections = sections && Object.keys(sections).length > 0;
    const shouldPassDraftId = draftId && (hasExistingFields || hasExistingSections);

    try {
      dispatch(sendMessageRequest());

      dispatch(addMessage({
        role: 'user',
        message,
        timestamp: new Date().toISOString()
      }));

      if (!sessionId) {
        const response = await apiForms.form.createSessionBuilderMessage({
          header,
          sessionId: null,
          message,
          draftId: shouldPassDraftId ? draftId : null
        });

        dispatch(sendMessageSuccess(response));

        return response;
      }

      const response = await apiForms.form.sendBuilderMessage({
        header,
        sessionId,
        message
      });

      dispatch(sendMessageSuccess(response));

      return response;
    } catch (error) {
      const { msg } = error;
      const customMsg = !!msg;

      dispatch(sendMessageFailure(error));
      if (!error.status === 402) {
        dispatch(actionSnack.showSnackbar({
          message: msg || 'Erro ao enviar mensagem',
          variant: 'error',
          autoHideDuration: 3500
        }));

        util.managerExceptionURIMessage({ error, customMsg });
      }

      throw error;
    }
  };

export const finishFormBuilderSession = ({ sessionId }) =>
  async (dispatch, getState, { apiForms }) => {
    const state = getState();
    let header = selectorLogin.getHeaderConfig(state);
    const formOrigin = selector.getFormOrigin(state);
    header = { ...header, formOrigin };

    try {
      dispatch(finishSessionRequest());

      const response = await apiForms.form.finishFormBuilderSession({
        header,
        sessionId
      });

      if (response.fields && response.fields.length > 0) {
        const fieldsIdsSimilar = response.fields.map(field => {
          if (field.similarityScore > 70) {
            return field.similarFieldId;
          }
          return null;
        });

        const fieldsIdsSimilarFiltered = fieldsIdsSimilar.filter(field => field !== null);

        if (fieldsIdsSimilar.length > 0) {
          dispatch(getFieldsLastVersionByFieldModelIds(fieldsIdsSimilarFiltered));
        }

      }



      dispatch(finishSessionSuccess(response));
      dispatch(processExtractedFormData({ ...response, resultPartial: false }));

      dispatch(actionSnack.showSnackbar({
        message: 'Formulário finalizado com sucesso!',
        variant: 'success',
        autoHideDuration: 3000
      }));

      return response;
    } catch (error) {
      const { msg } = error;
      const customMsg = !!msg;

      dispatch(finishSessionFailure(error));
      dispatch(actionSnack.showSnackbar({
        message: msg || 'Erro ao finalizar sessão',
        variant: 'error',
        autoHideDuration: 3500
      }));

      util.managerExceptionURIMessage({ error, customMsg });
      throw error;
    }
  };

export const listFormBuilderSessions = ({ status = 'active' } = {}) =>
  async (dispatch, getState, { apiForms }) => {
    const state = getState();
    let header = selectorLogin.getHeaderConfig(state);
    const formOrigin = selector.getFormOrigin(state);
    header = { ...header, formOrigin };

    try {
      dispatch(listSessionsRequest());

      const response = await apiForms.form.listFormBuilderSessions({
        header,
        status
      });

      dispatch(listSessionsSuccess(response));

      return response;
    } catch (error) {
      const { msg } = error;
      const customMsg = !!msg;

      dispatch(listSessionsFailure(error));
      dispatch(actionSnack.showSnackbar({
        message: msg || 'Erro ao listar sessões',
        variant: 'error',
        autoHideDuration: 3500
      }));

      util.managerExceptionURIMessage({ error, customMsg });
      throw error;
    }
  };

export const resumeFormBuilderSession = ({ sessionId }) =>
  async (dispatch, getState, { apiForms }) => {
    const state = getState();
    let header = selectorLogin.getHeaderConfig(state);
    const formOrigin = selector.getFormOrigin(state);
    header = { ...header, formOrigin };

    try {
      dispatch(getSessionRequest());

      const response = await apiForms.form.getFormBuilderSession({
        header,
        sessionId
      });

      dispatch(getSessionSuccess(response));

      dispatch(actionSnack.showSnackbar({
        message: 'Sessão retomada com sucesso!',
        variant: 'success',
        autoHideDuration: 2000
      }));

      return response;
    } catch (error) {
      const { msg } = error;
      const customMsg = !!msg;

      dispatch(getSessionFailure(error));
      dispatch(actionSnack.showSnackbar({
        message: msg || 'Erro ao retomar sessão',
        variant: 'error',
        autoHideDuration: 3500
      }));

      util.managerExceptionURIMessage({ error, customMsg });
      throw error;
    }
  };

export const handleWebSocketMessage = (message) => (dispatch) => {
  const { event, data } = message;

  switch (event) {
    case 'chat_typing':
      dispatch(setTyping(true));
      break;

    case 'chat_message':
      dispatch(setTyping(false));
      dispatch(addMessage({
        role: data.role,
        message: data.message,
        timestamp: new Date().toISOString()
      }));
      if (data.form && data.stats) {
        dispatch(updateFormPreview(data.stats));
        dispatch(processExtractedFormData({ ...data.form, stats: data.stats, resultPartial: true }));
      }
      break;

    case 'form_updated':
      dispatch(updateFormPreview(data.stats));
      dispatch(processExtractedFormData({ ...data.form, stats: data.stats, resultPartial: true }));
      break;

    case 'session_finished':
      dispatch(setTyping(false));
      dispatch(updateFormPreview(data.stats));
      dispatch(processExtractedFormData({ ...data.finalForm, stats: data.stats || {}, resultPartial: true }));
      dispatch(actionSnack.showSnackbar({
        message: 'Sessão finalizada pelo sistema!',
        variant: 'info',
        autoHideDuration: 3000
      }));
      break;

    case 'chat_error':
      dispatch(setTyping(false));
      const errorMessage = data.userMsg || data.error || 'Erro no chat';
      dispatch(addMessage({
        role: 'assistant',
        message: errorMessage,
        timestamp: new Date().toISOString(),
        isError: true
      }));

      dispatch(actionSnack.showSnackbar({
        message: errorMessage,
        variant: 'error',
        autoHideDuration: 3500
      }));
      if (data.status === 403) {
        dispatch(actionModal.onOpen({ modal: 'UPGRADE_PLAN_MODAL' }));
      }
      break;

    case 'connected':
      dispatch(setWebsocketConnected(true));
      break;

    default:
      break;
  }
};

export const replaceBySimilarField = (fieldId, field) => (dispatch, getState) => {
  dispatch(replaceBySimilarFieldFetchSuccess({
    fieldId,
    field,
  }));
};